module.exports = __webpack_public_path__ + "static/img/2_2_2.cb5b76a2.jpg";